/**
 * Default entity ATIs for Bitbucket (1P).
 * Combines devinfo pull request and repository ATIs.
 */
import type {
	CloudGraphPullRequestEntityAti,
	CloudGraphRepositoryEntityAti,
} from '@atlassian/search-client/common/types';

import { DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI } from './default-cloud-graph-devinfo-pull-request-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from './default-cloud-graph-devinfo-repository-entity-ati';

export type BitbucketEntityATI = CloudGraphPullRequestEntityAti | CloudGraphRepositoryEntityAti;

export type ReadonlyBitbucketEntityATI = readonly BitbucketEntityATI[];

export const DEFAULT_BITBUCKET_ENTITY_ATI: ReadonlyBitbucketEntityATI = [
	...DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI,
	...DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
];
